/**
 * Content Pack Manifest.
 *
 * Registers all known content packs with the PackLoader.
 * Packs are dynamically imported when loaded.
 */

import type { PackLoader } from '@/registry/PackLoader';

/**
 * Register all content packs with the loader.
 *
 * @param loader - The pack loader instance
 */
export function registerAllPacks(loader: PackLoader): void {
  // Core pack - always loads, no dependencies
  loader.registerManifest(
    'core',
    () => import('./core'),
    null, // No entitlement required
    [] // No dependencies
  );

  // Debug pack - developer-only, requires 'dev' entitlement (database-granted)
  loader.registerManifest(
    'debug',
    () => import('./debug'),
    'dev', // Only loads for developers
    ['core'] // Depends on core pack
  );

  // Future packs will be registered here:
  //
  // Premium pack
  // loader.registerManifest(
  //   'premium',
  //   () => import('./premium'),
  //   'premium_unlock',
  //   ['core']
  // );
  //
  // DLC packs
  // loader.registerManifest(
  //   'dlc-shores',
  //   () => import('./dlc-shores'),
  //   'dlc_shores',
  //   ['core', 'premium']
  // );
}
